import React from 'react';
import { observer } from 'mobx-react';
import { action } from 'mobx';
import PageTitle from '../../components/PageTitle';
import SearchComponent from '../../components/SearchComponent';
import ListComponent from '../../components/ListComponent';
import PaginationComponent from "../../components/PaginationComponent";
import appState from "../../state/AppState";
import { withApollo } from "react-apollo";
import BaseList from "../base/BaseList";
import EmailList from "../../components/list/EmailList";
import ListItemSelect from "../../components/listaddons/ListItemsSelect";
import TextListItem from "../../components/list/TextListItem";
import BaseListFilter from "../../subpages/BaseListFilter";
import ClientModel from "../../models/ClientModel";
import MoreButtons from "../../components/MoreButtons";
import PropsUtil from "../../util/PropsUtil";
import withTranslate from "../../translator/withTranslate";
import ClientListFilters from "./ClientListFilters";
import AppLogger from "../../util/AppLogger";
import ZoneColorList from "../../components/list/custom/ZoneColorList";
import ClientListNameItem from "../../components/list/ClientListNameItem";

@observer
class ClientPosList extends BaseList {

    constructor(props) {
        super(props);
        this.quickView = true;
        this.includeSavedFavour = true;
        this.includeChangeColum = true;
        this.includeFilters = true;
        this.includeDownload = true;
        this.includeSearch = true;
        this.deleteFilter = this.deleteFilter.bind(this);
        this.nameVariableStateFilter = "clientListFilters";
    }

    getListFields() {
        return [
            {
                title: this.props.t("Nombre"),
                name: "name",
                link: false,
                component: (props) => <TextListItem link={false} {...props} />,
                visible: true
            },

            {
                title: this.props.t("Código"),
                name: "code",
                link: true,
                component: (props) => <TextListItem link={true} {...props} />,
                visible: true
            },
            {
                title: this.props.t("Dirección"),
                name: "posAddress",
                link: false,
                component: (props) => <TextListItem link={true} {...props} />,
                visible: true
            },
            // {
            //     title: this.props.t("Zona"),
            //     name: "posZoneId",
            //     link: false,
            //     component: (props) => <ZoneColorList link={true} zoneWorkOrderList={true}
            //                                          icon="fas fa-map-marked-alt" {...props} />,
            //     visible: true
            // },
            {
                title: this.props.t("Zona"),
                name: "posZone.value",
                link: false,
                component: (props) => <ZoneColorList link={true} client={true}
                                                     icon="fas fa-map-marked-alt" {...props} />,
                visible: true
            },
            {
                title: this.props.t("Localidad"),
                name: "posCity",
                link: false,
                component: (props) => <TextListItem link={true} {...props} />,
                visible: true
            },
            {
                title: this.props.t("Provincia"),
                name: "posDistrict",
                link: false,
                component: (props) => <TextListItem link={true} {...props} />,
                visible: true
            },
            {
                title: this.props.t("Pertenece a"),
                name: "parentId",
                link: false,
                component: (props) => <ClientListNameItem clientName={true} link={true} {...props} />,
                visible: true
            },
            // {
            //     title: this.props.t("Cadena"),
            //     name: "chain.value",
            //     link: false,
            //     component: (props) => <TextListItem link={true} {...props} />,
            //     visible: true
            // },
        ];
    }

    openQuickEdit(row) {
        this.getListState().quickEdit.row = row;
        this.propsUtil.changeUrlRequest({
            idOrderClient: row.id,
            rightModal: "modalclient",
            rightModalTab: "general"
        })
    }

    getListState() {
        return appState.clientState;
    }

    getDefaultOrder() {
        return "name";
    }

    @action
    async componentDidMountImpl() {
        await Promise.all([
            appState.typifiedState.loadZones(),
            appState.clientCacheState.loadClientCache(),
        ]);
        appState.typifiedState.arrayLoadZones();
        appState.clientCacheState.loadArrayParentId();
        await super.componentDidMountImpl();
        appState['clientListFilters'].currentFilter.isPos = 0;
    }

    getModelQuery() {
        let cliente = new ClientModel();
        cliente.addRelatedTable('chain');
        cliente.addRelatedTable('posZone');
        cliente.filters.push(
            { "fieldName": "isPos", "fieldValue": '0', "filterOperator": "EQ" }
        );

        this.log("getModelQuery");
        this.log(cliente);
        return cliente;
    }

    render() {
        this.log("ClientList.render");
        this.propsUtil = new PropsUtil(this.props);
        let errorsMapped = this.getGraphErrorsFromStatus();
        let props = this.props;
        let { t } = this.props;
        let fields = this.stateListColumnsSelect.listFields;

        return (
            <div>
                <ListItemSelect
                    stateListColumnsSelect={this.stateListColumnsSelect}
                    name={"clientPos"}
                    subtitle='Clientes'
                />
                <BaseListFilter title={'Clientes'} listComponent={this} stateFilter={this.stateListFilter}>
                    {this.renderFilters()}
                </BaseListFilter>

                {this.renderAbsoluteTextLoadingQuery()}

                {this.getListStatus().formError &&
                <div class="alert alert-danger" role="alert">
                    {errorsMapped[""] != null &&
                    <React.Fragment>
                        {errorsMapped[""].map(error => <div>{error.message}</div>)}
                    </React.Fragment>
                    }
                </div>
                }

                <PageTitle
                    title={t("Clientes")}
                    buttons={[{ label: 'Nuevo', iconName: "fas fa-plus-circle", link: '/client/form/' }]}
                > <MoreButtons
                    actions={
                        [
                            {
                                title: "Crear Nuevo Cliente", onClick: () => {
                                    this.propsUtil.changeUrl("/client/form/")
                                }
                            },

                        ]
                    }
                />
                </PageTitle>
                <div className="card mb-3">
                    <div className="card-body pb-0">
                        <SearchComponent deleteFilter={this.deleteFilter}
                                         listState={this.getListState()}
                                         listData={this.getListData()}
                                         numEntriesPerPage={this.numEntriesPerPage}
                                         fields={fields}
                                         onDownloadExcelOrCsv={e => this.onDownloadExcelOrCsv(e)}
                                         includeSavedFavourites={this.includeSavedFavourites}
                                         includeChangeColumns={this.includeChangeColumns}
                                         includeFilters={this.includeFilters}
                                         includeDownload={this.includeDownload}
                                         includeSearch={this.includeSearch}
                                         stateListColumnsSelect={this.stateListColumnsSelect}
                                         {...props}
                                         model={this.getModelQuery()}
                                         listComponent={this}
                                         favouriteModalOpen={this.state.favouriteModalOpen}
                                         toggleFavouriteModal={this.toggleFavouriteModal.bind(this)}
                        />
                        <ListComponent listState={this.getListState()}
                                       quickView={this.quickView}
                                       getListState={this.getListState()}
                                       listData={this.getListData()}
                                       status={this.getListStatus()}
                                       fields={fields} urlForm={"/client/form"}
                                       openQuickEdit={(row) => this.openQuickEdit(row)}
                                       {...props}>
                            <EmailList name="name" />
                        </ListComponent>
                    </div>
                </div>
                <PaginationComponent listData={this.getListData()}
                                     numEntriesPerPage={this.numEntriesPerPage} {...props} />
            </div>
        );
    }

    renderFilters() {
        let { t } = this.props;
        return (
            <React.Fragment>
                <ClientListFilters key={"clientlist"} />
            </React.Fragment>
        )
    }

    log(msg) {
        AppLogger.get().debug(msg, this);
    }

}

export default withTranslate(withApollo(ClientPosList));
